import { SelectItem } from '@diamond/shared/types';
import { Dropdown } from '@diamond/shared/ui';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

interface FilterDivisiProps {
  divisionData: SelectItem[];
}

type FormProps = {
  division: string;
};

export const FilterDivisi: FC<FilterDivisiProps> = ({ divisionData }) => {
  const { pathname, query, push } = useRouter();
  const { register, handleSubmit } = useForm({
    defaultValues: {
      division: (query['division'] as string) || '',
    },
    values: {
      division: (query['division'] as string) || '',
    },
  });

  const submitHandler: SubmitHandler<FormProps> = ({
    division,
  }: {
    division: string;
  }) => {
    const url = {
      pathname,
      query: {
        ...query,
        cat1: null,
        cat2: null,
        cat3: null,
        division,
        page: 1,
      },
    };
    push(url, undefined, { shallow: true });
  };

  return (
    <form
      onSubmit={handleSubmit(submitHandler)}
      onChange={handleSubmit(submitHandler)}
    >
      <Dropdown
        name="division"
        label="Divisi"
        placeholder="Semua"
        size="md"
        items={divisionData}
        register={register}
      />
    </form>
  );
};
